import p1_img from './product_1.png';
import p2_img from './product_2.png';
import p3_img from './product_3.png';
import p4_img from './product_4.png';

let data_product = [
  {
    id: 1,
    name: "Elegant Women's Three-Piece Formal Suit Set",
    category: "women",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
  },
  {
    id: 2,
    name: "Boho Chic Women's Peasant Frock Dress",
    category: "women",
    image: p2_img,
    new_price: 75.0,
    old_price: 100.5,
  },
  {
    id: 3,
    name: "Classic Women's Cotton T-Shirt for Everyday Comfort",
    category: "women",
    image: p3_img,
    new_price: 40.0,
    old_price: 70.5,
  },
  {
    id: 4,
    name: "Trendy Women's Casual Button-Up Shirt",
    category: "women",
    image: p4_img,
    new_price: 65.0,
    old_price: 90.0,
  },
];

export default data_product;
